import utils from '@eitje/utils'
import {requireProps, childrenWithClonedProps} from '../../helpers'
import {FullScreenPageHeader, FloatingPageHeader} from './types'

export const PageHeader = ({type = 'fullScreen', className, left, right, center, ...props}) => {
	requireProps('PageHeader', {type})
	className = utils.makeCns('page-header', `page-header-${_.kebabCase(type)}`, className)

	const height = type == 'fullScreen' ? 'small' : 'regular'
	left = left && format(left, {height})
	center = center && format(center, {height})
	right = right && format(right, {height})

	const _props = {className, left, right, center, ...props}

	switch (type) {
		case 'fullScreen':
			return <FullScreenPageHeader {..._props} height="small" />
		case 'floating':
			return <FloatingPageHeader {..._props} height="large" />
	}
}

function format(children, props) {
	return childrenWithClonedProps({children, props})
}
